"use client";

import { c as _c } from "react/compiler-runtime";
import { USER_PAGE_TAB_IDS } from "@/components/user/layout/userTabs.config";
import CommonProfileLink from "@/components/user/utils/CommonProfileLink";
import type { ProfileActivityLog } from "@/entities/IProfile";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { useIdentity } from "@/hooks/useIdentity";
import { ProfileActivityLogType } from "@/types/enums";
import ProfileActivityLogItemTimeAgo from "./ProfileActivityLogItemTimeAgo";
export default function ProfileActivityLogItemWrapper(t0) {
  const $ = _c(29);
  const {
    log,
    children,
    user
  } = t0;
  const isArchived = log.type === ProfileActivityLogType.PROFILE_ARCHIVED;
  let t1;
  if ($[0] !== log.profile_handle || $[1] !== log.proxy_handle || $[2] !== user) {
    t1 = () => {
      if (!user || !log.proxy_handle) {
        return log?.profile_handle ?? "";
      }
      if (user.toLowerCase() === log.proxy_handle.toLowerCase()) {
        return log.proxy_handle;
      }
      return log.profile_handle ?? "";
    };
    $[0] = log.profile_handle;
    $[1] = log.proxy_handle;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getHandleOrWallet = t1;
  let handleOrWallet;
  let t2;
  if ($[4] !== getHandleOrWallet || $[5] !== user) {
    handleOrWallet = getHandleOrWallet();
    t2 = user?.toLowerCase() === handleOrWallet.toLowerCase() || !user;
    $[4] = getHandleOrWallet;
    $[5] = user;
    $[6] = handleOrWallet;
    $[7] = t2;
  } else {
    handleOrWallet = $[6];
    t2 = $[7];
  }
  const isCurrentUser = t2;
  const tabTarget = USER_PAGE_TAB_IDS.REP;
  const t3 = isArchived ? null : handleOrWallet;
  let t4;
  if ($[8] !== t3) {
    t4 = {
      handleOrWallet: t3,
      initialProfile: null
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    profile
  } = useIdentity(t4);
  const pfp = profile?.pfp ?? null;
  let t5;
  if ($[10] !== handleOrWallet || $[11] !== isArchived || $[12] !== pfp) {
    t5 = !isArchived && (pfp ? <img src={getScaledImageUri(pfp, ImageScale.W_AUTO_H_50)} alt={handleOrWallet} className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-rounded-md tw-bg-iron-700 tw-object-cover" /> : <div className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-rounded-md tw-bg-iron-700" />);
    $[10] = handleOrWallet;
    $[11] = isArchived;
    $[12] = pfp;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== handleOrWallet || $[15] !== isArchived || $[16] !== isCurrentUser) {
    t6 = !isArchived && <CommonProfileLink handleOrWallet={handleOrWallet} isCurrentUser={isCurrentUser} tabTarget={tabTarget} textClassName="tw-text-sm lg:tw-text-base tw-font-semibold tw-text-iron-100" />;
    $[14] = handleOrWallet;
    $[15] = isArchived;
    $[16] = isCurrentUser;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== children || $[19] !== t6) {
    t7 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t6}{children}</div>;
    $[18] = children;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t7) {
    t8 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-items-start tw-gap-x-3">{t5}{t7}</div>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== log) {
    t9 = <div className="tw-flex-shrink-0 tw-pl-3"><ProfileActivityLogItemTimeAgo log={log} /></div>;
    $[24] = log;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div className="tw-group tw-p-4 tw-bg-[#0A0A0C]/50 hover:tw-bg-[#0A0A0C] tw-border tw-border-solid tw-border-white/[0.12] hover:tw-border-white/[0.16] tw-rounded-lg tw-transition-all tw-duration-200"><div className="tw-flex tw-items-start tw-justify-between tw-gap-x-3">{t8}{t9}</div></div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}